import { markFunction } from 'owa-performance';
import OwaUserConfiguration from 'owa-service/lib/contract/OwaUserConfiguration';
import { setRTL } from 'office-ui-fabric-react/lib/Utilities';
import { loadInitialTheme } from 'owa-theme';
import { getOpxHostApi, isOpx } from 'owa-opx';

export default markFunction(async function initializeTheme(userConfig: OwaUserConfiguration) {
    document.dir = userConfig.SessionSettings.IsUserCultureRightToLeft ? 'rtl' : 'ltr';
    setRTL(userConfig.SessionSettings.IsUserCultureRightToLeft, true); // Ensure ui fabric has up to date RTL

    let opxPalette = isOpx() ? (await getOpxHostApi()).getOpxPalette() : undefined;

    await loadInitialTheme(
        userConfig.UserOptions.ThemeStorageId,
        userConfig.UserOptions.IsDarkModeTheme,
        userConfig.SegmentationSettings.Themes,
        opxPalette
    );
}, 'ti');
